import {BruteForceSymbol, BruteForceSymbolStates} from "./BruteForceSymbol";
import {SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";


export class BruteForceBlankSymbol extends BruteForceSymbol {
    constructor(symbolName: string, symPos: SimpleReelModelSymbolPosition, symbolState: BruteForceSymbolStates) {
        symbolName = "L5"
        super(symbolName, symPos, symbolState);
        this.visible = false;

    }

}